import {
  createThis2j2avj17cvnv2 as createThis,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID3gxj6tk5isa35 as VOID,
  indexOfwa4w6635jewi as indexOf,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  replaceqbix900hl8kl as replace,
  ArrayList3it5z8td81qkl as ArrayList,
  split2bvyvnrlcifjv as split,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  joinToString1cxrrlmo0chqs as joinToString,
  substring3saq8ornu0luv as substring,
  startsWith26w8qjqapeeq6 as startsWith,
  substringiqarkczpya5m as substring_0,
  substringAfterLast3r0t0my8cpqhk as substringAfterLast,
  get_lastIndexld83bqhfgcdd as get_lastIndex,
  lastIndexOfpmd3ei5son2n as lastIndexOf,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  trimEndvvzjdhan75g as trimEnd,
  trim6jpmwojjgb3l as trim,
  substringBefore3n7kj60w69hju as substringBefore,
  contains2el4s70rdq4ld as contains,
  printStackTrace18lnx7a39cni as printStackTrace,
  constructCallableReference23y65rf941mch as constructCallableReference,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  toString1pkumu07cwy4m as toString,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  boxApply1qmzdb3dh90hg as boxApply,
  Long2qws0ah9gnpki as Long,
  fromInt1lka3ktyu79a4 as fromInt,
  subtract16cg4lfi29fq9 as subtract,
  compare2uud5j30pw5xc as compare,
  convertToIntofdoxh9bstof as convertToInt,
  Enum3alwj03lh1n41 as Enum,
  toString30pk9tzaqopn as toString_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equalsLong28bsrfhwvd686 as equalsLong,
  equals2au1ep9vhcato as equals,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  get6d5x931vk0s as get,
  protoOf180f3jzyo7rfj as protoOf,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
  longRangeToLong1wnzlyc7cu6kp as longRangeToLong,
  toString336ienavfnzn0 as toString_1,
} from './kotlin-kotlin-stdlib.mjs';
import {
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  asyncz02dsa2nb2zt as async,
} from './kotlinx-coroutines-core.mjs';
import {
  Companion_getInstance9zqhf8dpcsyh as Companion_getInstance,
  DateTime2gld4ho36azq9 as DateTime,
  DateTime__toString_impl_cnuejegqn25aq3mm89 as DateTime__toString_impl_cnueje,
  DateTime__hashCode_impl_yf0bc91uk36yk65yixv as DateTime__hashCode_impl_yf0bc9,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  readBytesUpTo3v2pxuza3qdby as readBytesUpTo,
  openSync2m3qn99fqytu0 as openSync,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import { get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName } from './korlibs-platform-root-korlibs-platform.mjs';
import { Mixin3lmkm5hum2vdj as Mixin } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  toString2x583ovdqfjci as toString_2,
  get_UTF82geyfhi1l22xl as get_UTF8,
} from './korlibs-string-root-korlibs-string.mjs';
import { Companion_getInstance2x8uwmfpm0tzj as Companion_getInstance_0 } from './korlibs-io-fs-root-korlibs-io-fs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class FinalVfsFile {
  constructor(file) {
    return new.target.gbf(file);
  }
  static gbf(file) {
    var $this = createThis(this);
    $this.fbf_1 = file;
    return $this;
  }
  static hbf(vfs, path) {
    return this.gbf(vfs.wi(path));
  }
  ibf() {
    return this.fbf_1.lbf_1;
  }
  obf() {
    return this.fbf_1.mbf_1;
  }
  toString() {
    return 'FinalVfsFile(file=' + this.fbf_1.toString() + ')';
  }
  hashCode() {
    return this.fbf_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FinalVfsFile))
      return false;
    var tmp0_other_with_cast = other instanceof FinalVfsFile ? other : THROW_CCE();
    if (!this.fbf_1.equals(tmp0_other_with_cast.fbf_1))
      return false;
    return true;
  }
}
class VfsNamed {
  constructor(pathInfo) {
    this.rbf_1 = pathInfo;
  }
  qbf() {
    return this.rbf_1;
  }
}
class Vfs {
  constructor($box) {
    boxApply(this, $box);
  }
  ubg() {
    return '';
  }
  vbg(path) {
    return _PathInfo___get_fullPath__impl__21fx6x(lightCombine(get_pathInfo(this.ubg()), get_pathInfo(path)));
  }
  wbg() {
    return new VfsFile(this, '');
  }
  wi(path) {
    return this.wbg().wi(path);
  }
  cbg(path) {
    return this.wbg().wi(path);
  }
  *lb6($completion) {
    return Unit_instance;
  }
  xbg(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache) {
    // Inline function 'kotlin.also' call
    var this_0 = new VfsStat(this.cbg(path), true, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, VOID, id);
    if (cache)
      this_0.dbg_1.nbf_1 = this_0;
    return this_0;
  }
  ybg(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache, $super) {
    device = device === VOID ? new Long(-1, -1) : device;
    inode = inode === VOID ? new Long(-1, -1) : inode;
    mode = mode === VOID ? 511 : mode;
    owner = owner === VOID ? 'nobody' : owner;
    group = group === VOID ? 'nobody' : group;
    createTime = createTime === VOID ? Companion_getInstance().t9v_1 : createTime;
    modifiedTime = modifiedTime === VOID ? Companion_getInstance().t9v_1 : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? modifiedTime : lastAccessTime;
    extraInfo = extraInfo === VOID ? null : extraInfo;
    id = id === VOID ? null : id;
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.xbg(path, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, cache) : $super.xbg.call(this, path, isDirectory, size, device, inode, mode, owner, group, new DateTime(createTime), new DateTime(modifiedTime), new DateTime(lastAccessTime), extraInfo, id, cache);
  }
  zbg(path, extraInfo, cache, exception) {
    return new VfsStat(this.cbg(path), false, false, new Long(0, 0), new Long(-1, -1), new Long(-1, -1), 511, 'nobody', 'nobody', Companion_getInstance().t9v_1, Companion_getInstance().t9v_1, Companion_getInstance().t9v_1, extraInfo, VOID, VOID, exception);
  }
  abh(path, extraInfo, cache, exception, $super) {
    extraInfo = extraInfo === VOID ? null : extraInfo;
    cache = cache === VOID ? false : cache;
    exception = exception === VOID ? null : exception;
    return $super === VOID ? this.zbg(path, extraInfo, cache, exception) : $super.zbg.call(this, path, extraInfo, cache, exception);
  }
  *wbf(path, mode, $completion) {
    unsupported(this);
  }
  *ybf(path, range, $completion) {
    // Inline function 'korlibs.io.async.useIt' call
    // Inline function 'korlibs.io.async.use' call
    var this_0 = yield* this.wbf(path, VfsOpenMode_READ_getInstance(), $completion);
    var error = null;
    var tmp;
    try {
      this_0.yb8_1 = range.s3();
      // Inline function 'kotlin.Long.minus' call
      var this_1 = new Long(2147483647, 0);
      var tmp0 = subtract(this_1, fromInt(1));
      // Inline function 'kotlin.math.min' call
      var b = subtract(range.r3(), range.s3());
      var tmp$ret$4 = compare(tmp0, b) <= 0 ? tmp0 : b;
      tmp = yield* readBytesUpTo(this_0, convertToInt(tmp$ret$4) + 1 | 0, $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        error = e;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var result = tmp;
    if (this_0 == null)
      null;
    else
      yield* this_0.lb6($completion);
    if (!(error == null))
      throw error;
    return result;
  }
  *abg(path, $completion) {
    return this.abh(path);
  }
  *pbf(path, $completion) {
    return FinalVfsFile.hbf(this, path);
  }
  toString() {
    return get_portableSimpleName(getKClassFromExpression(this));
  }
}
class Proxy extends Vfs {
  constructor() {
    super();
    this.sbf_1 = null;
  }
  *pbf(path, $completion) {
    return yield* getUnderlyingUnscapedFile(yield* (yield* this.vbf($completion)).ubf(path, $completion), $completion);
  }
  *tbf($completion) {
    return Unit_instance;
  }
  *vbf($completion) {
    if (this.sbf_1 == null) {
      var tmp = this;
      // Inline function 'kotlin.js.getCoroutineContext' call
      var tmp$ret$0 = $completion.od();
      var tmp_0 = CoroutineScope(tmp$ret$0.ep(SupervisorJob()).ep(CoroutineName.b1u('Initializing.' + this.toString())));
      tmp.sbf_1 = async(tmp_0, VOID, VOID, Vfs$Proxy$initOnce$slambda(this));
    }
    yield* ensureNotNull(this.sbf_1).m1q($completion);
    return this;
  }
  *wbf(path, mode, $completion) {
    return yield* (yield* (yield* this.vbf($completion)).ubf(path, $completion)).xbf(mode, $completion);
  }
  *ybf(path, range, $completion) {
    return yield* (yield* (yield* this.vbf($completion)).ubf(path, $completion)).zbf(range, $completion);
  }
  *abg(path, $completion) {
    return (yield* (yield* (yield* this.vbf($completion)).ubf(path, $completion)).bbg($completion)).tbg(this.cbg(path));
  }
}
class VfsOpenMode extends Enum {
  constructor(name, ordinal, cmode, write, createIfNotExists, truncate, read, append, createNew) {
    createIfNotExists = createIfNotExists === VOID ? false : createIfNotExists;
    truncate = truncate === VOID ? false : truncate;
    read = read === VOID ? true : read;
    append = append === VOID ? false : append;
    createNew = createNew === VOID ? false : createNew;
    super(name, ordinal);
    this.dbh_1 = cmode;
    this.ebh_1 = write;
    this.fbh_1 = createIfNotExists;
    this.gbh_1 = truncate;
    this.hbh_1 = read;
    this.ibh_1 = append;
    this.jbh_1 = createNew;
  }
}
class VfsStat {
  constructor(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) {
    device = device === VOID ? new Long(-1, -1) : device;
    inode = inode === VOID ? new Long(-1, -1) : inode;
    mode = mode === VOID ? 511 : mode;
    owner = owner === VOID ? 'nobody' : owner;
    group = group === VOID ? 'nobody' : group;
    createTime = createTime === VOID ? Companion_getInstance().t9v_1 : createTime;
    modifiedTime = modifiedTime === VOID ? createTime : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? modifiedTime : lastAccessTime;
    extraInfo = extraInfo === VOID ? null : extraInfo;
    kind = kind === VOID ? null : kind;
    id = id === VOID ? null : id;
    exception = exception === VOID ? null : exception;
    this.dbg_1 = file;
    this.ebg_1 = exists;
    this.fbg_1 = isDirectory;
    this.gbg_1 = size;
    this.hbg_1 = device;
    this.ibg_1 = inode;
    this.jbg_1 = mode;
    this.kbg_1 = owner;
    this.lbg_1 = group;
    this.mbg_1 = createTime;
    this.nbg_1 = modifiedTime;
    this.obg_1 = lastAccessTime;
    this.pbg_1 = extraInfo;
    this.qbg_1 = kind;
    this.rbg_1 = id;
    this.sbg_1 = exception;
  }
  qbf() {
    return this.dbg_1.qbf();
  }
  kbh(showFile) {
    // Inline function 'kotlin.also' call
    var this_0 = ArrayList.n2(16);
    if (showFile)
      this_0.d2('file=' + this.dbg_1.toString());
    else
      this_0.d2('file=' + this.dbg_1.ubg());
    this_0.d2('exists=' + this.ebg_1);
    this_0.d2('isDirectory=' + this.fbg_1);
    this_0.d2('size=' + this.gbg_1.toString());
    this_0.d2('device=' + this.hbg_1.toString());
    this_0.d2('inode=' + this.ibg_1.toString());
    this_0.d2('mode=' + this.jbg_1);
    this_0.d2('owner=' + this.kbg_1);
    this_0.d2('group=' + this.lbg_1);
    this_0.d2('createTime=' + DateTime__toString_impl_cnueje(this.mbg_1));
    this_0.d2('modifiedTime=' + DateTime__toString_impl_cnueje(this.nbg_1));
    this_0.d2('lastAccessTime=' + DateTime__toString_impl_cnueje(this.obg_1));
    this_0.d2('extraInfo=' + toString_0(this.pbg_1));
    if (!(this.qbg_1 == null)) {
      this_0.d2('kind=' + toString_0(this.qbg_1));
    }
    this_0.d2('id=' + this.rbg_1);
    return 'VfsStat(' + joinToString(this_0, ', ') + ')';
  }
  toString() {
    return this.kbh(true);
  }
  lbh(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) {
    return new VfsStat(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception);
  }
  tbg(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception, $super) {
    file = file === VOID ? this.dbg_1 : file;
    exists = exists === VOID ? this.ebg_1 : exists;
    isDirectory = isDirectory === VOID ? this.fbg_1 : isDirectory;
    size = size === VOID ? this.gbg_1 : size;
    device = device === VOID ? this.hbg_1 : device;
    inode = inode === VOID ? this.ibg_1 : inode;
    mode = mode === VOID ? this.jbg_1 : mode;
    owner = owner === VOID ? this.kbg_1 : owner;
    group = group === VOID ? this.lbg_1 : group;
    createTime = createTime === VOID ? this.mbg_1 : createTime;
    modifiedTime = modifiedTime === VOID ? this.nbg_1 : modifiedTime;
    lastAccessTime = lastAccessTime === VOID ? this.obg_1 : lastAccessTime;
    extraInfo = extraInfo === VOID ? this.pbg_1 : extraInfo;
    kind = kind === VOID ? this.qbg_1 : kind;
    id = id === VOID ? this.rbg_1 : id;
    exception = exception === VOID ? this.sbg_1 : exception;
    return $super === VOID ? this.lbh(file, exists, isDirectory, size, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, kind, id, exception) : $super.lbh.call(this, file, exists, isDirectory, size, device, inode, mode, owner, group, new DateTime(createTime), new DateTime(modifiedTime), new DateTime(lastAccessTime), extraInfo, kind, id, exception);
  }
  hashCode() {
    var result = this.dbg_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.ebg_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.fbg_1) | 0;
    result = imul(result, 31) + this.gbg_1.hashCode() | 0;
    result = imul(result, 31) + this.hbg_1.hashCode() | 0;
    result = imul(result, 31) + this.ibg_1.hashCode() | 0;
    result = imul(result, 31) + this.jbg_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.kbg_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.lbg_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.mbg_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.nbg_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.obg_1) | 0;
    result = imul(result, 31) + (this.pbg_1 == null ? 0 : hashCode(this.pbg_1)) | 0;
    result = imul(result, 31) + (this.qbg_1 == null ? 0 : hashCode(this.qbg_1)) | 0;
    result = imul(result, 31) + (this.rbg_1 == null ? 0 : getStringHashCode(this.rbg_1)) | 0;
    result = imul(result, 31) + (this.sbg_1 == null ? 0 : hashCode(this.sbg_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsStat))
      return false;
    var tmp0_other_with_cast = other instanceof VfsStat ? other : THROW_CCE();
    if (!this.dbg_1.equals(tmp0_other_with_cast.dbg_1))
      return false;
    if (!(this.ebg_1 === tmp0_other_with_cast.ebg_1))
      return false;
    if (!(this.fbg_1 === tmp0_other_with_cast.fbg_1))
      return false;
    if (!equalsLong(this.gbg_1, tmp0_other_with_cast.gbg_1))
      return false;
    if (!equalsLong(this.hbg_1, tmp0_other_with_cast.hbg_1))
      return false;
    if (!equalsLong(this.ibg_1, tmp0_other_with_cast.ibg_1))
      return false;
    if (!(this.jbg_1 === tmp0_other_with_cast.jbg_1))
      return false;
    if (!(this.kbg_1 === tmp0_other_with_cast.kbg_1))
      return false;
    if (!(this.lbg_1 === tmp0_other_with_cast.lbg_1))
      return false;
    if (!equals(this.mbg_1, tmp0_other_with_cast.mbg_1))
      return false;
    if (!equals(this.nbg_1, tmp0_other_with_cast.nbg_1))
      return false;
    if (!equals(this.obg_1, tmp0_other_with_cast.obg_1))
      return false;
    if (!equals(this.pbg_1, tmp0_other_with_cast.pbg_1))
      return false;
    if (!equals(this.qbg_1, tmp0_other_with_cast.qbg_1))
      return false;
    if (!(this.rbg_1 == tmp0_other_with_cast.rbg_1))
      return false;
    if (!equals(this.sbg_1, tmp0_other_with_cast.sbg_1))
      return false;
    return true;
  }
}
class Companion {}
class VfsCachedStatContext {
  constructor(stat) {
    this.mbh_1 = stat;
  }
  j3() {
    return Companion_instance;
  }
}
class VfsFile extends VfsNamed {
  constructor(vfs, path) {
    super(get_pathInfo(path));
    this.kbf_1 = new Mixin();
    this.lbf_1 = vfs;
    this.mbf_1 = path;
    this.nbf_1 = null;
  }
  o9u(_set____db54di) {
    this.kbf_1.o9u(_set____db54di);
  }
  p9u() {
    return this.kbf_1.p9u();
  }
  x1m() {
    return new VfsFile(this.lbf_1, get_folder_0(this));
  }
  wbg() {
    return this.lbf_1.wbg();
  }
  ubg() {
    return this.lbf_1.vbg(this.mbf_1);
  }
  wi(path) {
    return new VfsFile(this.lbf_1, _PathInfo___get_fullPath__impl__21fx6x(combine(get_pathInfo(this.mbf_1), get_pathInfo(path))));
  }
  *xbf(mode, $completion) {
    return yield* this.lbf_1.wbf(this.mbf_1, mode, $completion);
  }
  nbh(mode, $completion, $super) {
    mode = mode === VOID ? VfsOpenMode_READ_getInstance() : mode;
    return $super === VOID ? this.xbf(mode, $completion) : $super.xbf.call(this, mode, $completion);
  }
  *zbf(range, $completion) {
    return yield* this.lbf_1.ybf(this.mbf_1, range, $completion);
  }
  *obh(range, $completion) {
    return yield* this.lbf_1.ybf(this.mbf_1, toLongRange(range), $completion);
  }
  *pbh($completion) {
    return yield* this.lbf_1.ybf(this.mbf_1, get_LONG_ZERO_TO_MAX_RANGE(), $completion);
  }
  *qbh($completion) {
    return yield* this.pbh($completion);
  }
  *rbh($completion) {
    return yield* this.pbh($completion);
  }
  *sbh(charset, $completion) {
    return toString_2(yield* this.qbh($completion), charset);
  }
  tbh(charset, $completion, $super) {
    charset = charset === VOID ? get_UTF8() : charset;
    return $super === VOID ? this.sbh(charset, $completion) : $super.sbh.call(this, charset, $completion);
  }
  *bbg($completion) {
    var tmp0_elvis_lhs = this.nbf_1;
    return tmp0_elvis_lhs == null ? (yield* this.lbf_1.abg(this.mbf_1, $completion)) : tmp0_elvis_lhs;
  }
  *ubh($completion) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      tmp = (yield* this.lbf_1.abg(this.mbf_1, $completion)).ebg_1;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (false) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  vbh() {
    return Companion_instance_0.wbh(this);
  }
  toString() {
    return this.lbf_1.toString() + '[' + this.mbf_1 + ']';
  }
  hashCode() {
    var result = hashCode(this.lbf_1);
    result = imul(result, 31) + getStringHashCode(this.mbf_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsFile))
      return false;
    var tmp0_other_with_cast = other instanceof VfsFile ? other : THROW_CCE();
    if (!equals(this.lbf_1, tmp0_other_with_cast.lbf_1))
      return false;
    if (!(this.mbf_1 === tmp0_other_with_cast.mbf_1))
      return false;
    return true;
  }
}
class Companion_0 {
  wbh(jailRoot) {
    return (new JailVfs(jailRoot, Unit_instance)).wbg();
  }
}
class JailVfs extends Proxy {
  constructor(jailRoot, dummy) {
    super();
    this.ybh_1 = jailRoot;
    this.zbh_1 = normalize(this.ybh_1.qbf());
  }
  *ubf(path, $completion) {
    return this.ybh_1.wi(trim(normalize(get_pathInfo(path)), charArrayOf([_Char___init__impl__6a9atx(47)])));
  }
  ubg() {
    return this.ybh_1.ubg();
  }
  toString() {
    return 'JailVfs(' + this.ybh_1.toString() + ')';
  }
}
class Companion_1 {}
class LocalVfs extends Vfs {
  constructor(fs) {
    fs = fs === VOID ? Companion_getInstance_0() : fs;
    super();
    this.abi_1 = fs;
  }
  toString() {
    return 'LocalVfs';
  }
}
class UrlVfs extends Vfs {
  constructor(url, dummy, failFromStatus) {
    failFromStatus = failFromStatus === VOID ? true : failFromStatus;
    super();
    this.bbi_1 = url;
    this.cbi_1 = failFromStatus;
    this.dbi_1 = this.bbi_1;
  }
  ubg() {
    return this.dbi_1;
  }
  ebi(path) {
    var result = trim(this.bbi_1, charArrayOf([_Char___init__impl__6a9atx(47)])) + toString_1(_Char___init__impl__6a9atx(47)) + trim(path, charArrayOf([_Char___init__impl__6a9atx(47)]));
    return result;
  }
}
//endregion
function *getUnderlyingUnscapedFile(_this__u8e3s4, $completion) {
  return yield* _this__u8e3s4.lbf_1.pbf(_this__u8e3s4.mbf_1, $completion);
}
function _PathInfo___init__impl__vpw96a(fullPath) {
  return fullPath;
}
function _PathInfo___get_fullPath__impl__21fx6x($this) {
  return $this;
}
function get_baseName(_this__u8e3s4) {
  return get_baseName_0(_this__u8e3s4.qbf());
}
function normalize(_this__u8e3s4, removeEndSlash) {
  removeEndSlash = removeEndSlash === VOID ? true : removeEndSlash;
  var path = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var schemeIndex = indexOf(path, ':');
  var tmp;
  if (schemeIndex >= 0) {
    var take = startsWith(substring(path, schemeIndex), '://') ? 3 : 1;
    tmp = substring_0(path, 0, schemeIndex + take | 0) + normalize(get_pathInfo(substring(path, schemeIndex + take | 0)), removeEndSlash);
  } else {
    var path2 = replace(path, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47));
    var out = ArrayList.p2();
    var path2PathLength;
    // Inline function 'kotlin.also' call
    var this_0 = split(path2, ['/']);
    path2PathLength = this_0.s2();
    // Inline function 'korlibs.io.file.fastForEachWithIndex' call
    var n = 0;
    while (n < this_0.s2()) {
      var tmp0 = n;
      var part = this_0.u2(n);
      switch (part) {
        case '':
          if (out.n1() || !removeEndSlash) {
            // Inline function 'kotlin.collections.plusAssign' call
            out.d2('');
          }

          break;
        case '.':
          if (tmp0 === (path2PathLength - 1 | 0) && !removeEndSlash) {
            // Inline function 'kotlin.collections.plusAssign' call
            out.d2('');
          }

          break;
        case '..':
          var tmp_0;
          // Inline function 'kotlin.collections.isNotEmpty' call

          if (!out.n1()) {
            tmp_0 = !(tmp0 === 1);
          } else {
            tmp_0 = false;
          }

          if (tmp_0) {
            out.g5(out.s2() - 1 | 0);
          }

          break;
        default:
          // Inline function 'kotlin.collections.plusAssign' call

          out.d2(part);
          break;
      }
      n = n + 1 | 0;
    }
    tmp = joinToString(out, '/');
  }
  return tmp;
}
function get_pathInfo(_this__u8e3s4) {
  return _PathInfo___init__impl__vpw96a(_this__u8e3s4);
}
function get_fullPathNormalized(_this__u8e3s4) {
  return replace(_PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4), _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47));
}
function get_parent(_this__u8e3s4) {
  return _PathInfo___init__impl__vpw96a(get_folder(_this__u8e3s4));
}
function get_baseName_0(_this__u8e3s4) {
  return substringAfterLast(get_fullPathNormalized(_this__u8e3s4), _Char___init__impl__6a9atx(47));
}
function get_folder(_this__u8e3s4) {
  var tmp = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var tmp0_elvis_lhs = lastIndexOfOrNull(get_fullPathNormalized(_this__u8e3s4), _Char___init__impl__6a9atx(47));
  return substring_0(tmp, 0, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs);
}
function lastIndexOfOrNull(_this__u8e3s4, char, startIndex) {
  startIndex = startIndex === VOID ? get_lastIndex(_this__u8e3s4) : startIndex;
  // Inline function 'kotlin.takeIf' call
  var this_0 = lastIndexOf(_this__u8e3s4, char, startIndex);
  var tmp;
  if (this_0 >= 0) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  return tmp;
}
function lightCombine(_this__u8e3s4, access) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var access_0 = _PathInfo___get_fullPath__impl__21fx6x(access);
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  if (charSequenceLength(base) > 0) {
    tmp = trimEnd(base, charArrayOf([_Char___init__impl__6a9atx(47)])) + '/' + trim(access_0, charArrayOf([_Char___init__impl__6a9atx(47)]));
  } else {
    tmp = access_0;
  }
  var res = tmp;
  return get_pathInfo(res);
}
function get_folder_0(_this__u8e3s4) {
  return get_folder(_this__u8e3s4.qbf());
}
function combine(_this__u8e3s4, access) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  var access_0 = _PathInfo___get_fullPath__impl__21fx6x(access);
  return get_pathInfo(isAbsolute(get_pathInfo(access_0)) ? normalize(get_pathInfo(access_0)) : normalize(get_pathInfo(base + '/' + access_0)));
}
function isAbsolute(_this__u8e3s4) {
  var base = _PathInfo___get_fullPath__impl__21fx6x(_this__u8e3s4);
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(base) === 0)
    return false;
  var b = substringBefore(replace(base, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(47));
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(b) === 0)
    return true;
  if (contains(b, _Char___init__impl__6a9atx(58)))
    return true;
  return false;
}
function Vfs$Proxy$initOnce$slambda(this$0) {
  return constructCallableReference(function *($this$async, $completion) {
    var tmp;
    try {
      tmp = yield* this$0.tbf($completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        tmp_0 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  }, 1);
}
function unsupported($this) {
  throw UnsupportedOperationException.a1('unsupported for ' + toString(getKClassFromExpression($this)) + ' : ' + $this.toString());
}
var VfsOpenMode_READ_instance;
var VfsOpenMode_WRITE_instance;
var VfsOpenMode_APPEND_instance;
var VfsOpenMode_CREATE_OR_TRUNCATE_instance;
var VfsOpenMode_CREATE_instance;
var VfsOpenMode_CREATE_NEW_instance;
var VfsOpenMode_entriesInitialized;
function VfsOpenMode_initEntries() {
  if (VfsOpenMode_entriesInitialized)
    return Unit_instance;
  VfsOpenMode_entriesInitialized = true;
  VfsOpenMode_READ_instance = new VfsOpenMode('READ', 0, 'rb', false);
  VfsOpenMode_WRITE_instance = new VfsOpenMode('WRITE', 1, 'r+b', true, true);
  VfsOpenMode_APPEND_instance = new VfsOpenMode('APPEND', 2, 'a+b', true, true, VOID, VOID, true);
  VfsOpenMode_CREATE_OR_TRUNCATE_instance = new VfsOpenMode('CREATE_OR_TRUNCATE', 3, 'w+b', true, true, true);
  VfsOpenMode_CREATE_instance = new VfsOpenMode('CREATE', 4, 'w+b', true, true);
  VfsOpenMode_CREATE_NEW_instance = new VfsOpenMode('CREATE_NEW', 5, 'w+b', true);
}
var Companion_instance;
function Companion_getInstance_1() {
  return Companion_instance;
}
function VfsOpenMode_READ_getInstance() {
  VfsOpenMode_initEntries();
  return VfsOpenMode_READ_instance;
}
function get_LONG_ZERO_TO_MAX_RANGE() {
  _init_properties_VfsFile_kt__9wj0sz();
  return LONG_ZERO_TO_MAX_RANGE;
}
var LONG_ZERO_TO_MAX_RANGE;
function *readAsSyncStream(_this__u8e3s4, $completion) {
  return openSync(yield* _this__u8e3s4.qbh($completion));
}
function toLongRange(_this__u8e3s4) {
  _init_properties_VfsFile_kt__9wj0sz();
  return longRangeToLong(fromInt(_this__u8e3s4.s3()), fromInt(_this__u8e3s4.r3()));
}
var properties_initialized_VfsFile_kt_lqx1ld;
function _init_properties_VfsFile_kt__9wj0sz() {
  if (!properties_initialized_VfsFile_kt_lqx1ld) {
    properties_initialized_VfsFile_kt_lqx1ld = true;
    LONG_ZERO_TO_MAX_RANGE = longRangeToLong(new Long(0, 0), new Long(-1, 2147483647));
  }
}
var Companion_instance_0;
function Companion_getInstance_2() {
  return Companion_instance_0;
}
var Companion_instance_1;
function Companion_getInstance_3() {
  return Companion_instance_1;
}
//region block: post-declaration
initMetadataForClass(FinalVfsFile, 'FinalVfsFile');
initMetadataForClass(VfsNamed, 'VfsNamed');
initMetadataForClass(Vfs, 'Vfs', VOID, VOID, VOID, [1, 0, 2, 4, 3]);
initMetadataForClass(Proxy, 'Proxy', VOID, VOID, VOID, [1, 0, 4, 2, 3]);
initMetadataForClass(VfsOpenMode, 'VfsOpenMode');
initMetadataForClass(VfsStat, 'VfsStat');
initMetadataForCompanion(Companion);
protoOf(VfsCachedStatContext).ae = get;
protoOf(VfsCachedStatContext).dp = fold;
protoOf(VfsCachedStatContext).cp = minusKey;
protoOf(VfsCachedStatContext).ep = plus;
initMetadataForClass(VfsCachedStatContext, 'VfsCachedStatContext', VOID, VOID, [Element]);
initMetadataForClass(VfsFile, 'VfsFile', VOID, VOID, VOID, [0, 2, 3, 1, 4, 5]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(JailVfs, 'JailVfs', VOID, VOID, VOID, [1, 0, 4, 2, 3]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(LocalVfs, 'LocalVfs', VOID, VOID, VOID, [1, 4, 0, 2, 3]);
initMetadataForClass(UrlVfs, 'UrlVfs', VOID, VOID, VOID, [1, 0, 2, 4, 3]);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
//endregion
//region block: exports
export {
  _PathInfo___init__impl__vpw96a as _PathInfo___init__impl__vpw96a3sb4896r1qzn4,
  _PathInfo___get_fullPath__impl__21fx6x as _PathInfo___get_fullPath__impl__21fx6xos59ykam8fuk,
  Companion_instance as Companion_instance2ce9qcs6y3vbs,
  VfsOpenMode_READ_getInstance as VfsOpenMode_READ_getInstance3qf5ep0pmw6s7,
  getUnderlyingUnscapedFile as getUnderlyingUnscapedFilenlplw797lms5,
  readAsSyncStream as readAsSyncStream39593nw0zd799,
  LocalVfs as LocalVfs18bzski76hhpp,
  UrlVfs as UrlVfs292f1sja450ff,
  Proxy as Proxy2ri7nr2ijtx4g,
  VfsCachedStatContext as VfsCachedStatContext2gte5m09f8ox9,
  Vfs as Vfs3mgmizq3oi7gy,
  get_baseName_0 as get_baseName7iz3sifr1imo,
  get_baseName as get_baseName2yf63efofm8te,
  normalize as normalize34ppus0f5oo02,
  get_parent as get_parent1emraos91g459,
  get_pathInfo as get_pathInfo26tycr2r540oz,
};
//endregion
